'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoWaterdrop = function IoWaterdrop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.2 3c3.1 3.3 11.3 12.5 11.3 22.5 0 6.7-5.6 12-12.5 12-4.4 0-8.3-2.1-10.5-5.4-0.4-0.7-0.8-1.5-1.1-2.3-0.6-1.3-0.9-2.7-0.9-4.3v-0.3c0.1-5.2 2.4-10.2 5-14.3 1.6-2.4 3.3-4.4 4.6-6 0.7-0.8 1.3-1.4 1.7-1.9l0.1 0c0.3-0.3 0.6-0.5 1.1-0.5 0.4 0 0.8 0.2 1.1 0.5z m-1.2 30.1c4.3 0 7.8-3.5 7.8-7.8 0-1.1-0.2-2.2-0.6-3.1-1.3 5.1-5.5 9.1-10.6 10.1 1 0.5 2.2 0.8 3.4 0.8z' })
        )
    );
};

exports.default = IoWaterdrop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/waterdrop.js
// module id = 2527
// module chunks = 0